define('views/content/cd_licenses',['require','views/base/list_page_view','views/components/cd_product/cd_products','collections/cd_products','views/components/purchase_information/purchase_information','text!templates/content/cd_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CDProductsView = require('views/components/cd_product/cd_products');
    var CDProductsCollection = require('collections/cd_products');

    var PurchaseInformationView = require('views/components/purchase_information/purchase_information');


    var temp = require("text!templates/content/cd_licenses.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-licenses-page',
        titleKey: 'licenses',

        setCollection: function () {
            this.collection = new CDProductsCollection();
        },

        regions: function(){
            return {
                ListContainer: ".main-list-container",
                PurchaseInformationContainer: ".purchase-information-container"
            };
        },

        onRender: function() {
            this.ListContainer.show(new CDProductsView({
                collection: this.collection
            }));

            this.PurchaseInformationContainer.show(new PurchaseInformationView());

        }

    });
});
